// components/NoAccess.jsx
import React, { useState, useEffect } from 'react';
import './NoAccess.css'; // if you're using an external CSS file
import { useSelector } from 'react-redux';
import { getRole } from '../Redux/selecters';
import { useNavigate } from 'react-router-dom';

const NoAccess = () => {

    const role = useSelector(getRole);
    const [userRole, setUserRole] = useState(role);
    const navigate = useNavigate();

    useEffect(() => {
        if (!role) {
            window.location.href = 'https://app.pro360erp.com/';
        }
    }, [role]);
    return (
        <div className="no-access-container">
            <img
                src="https://cdn-icons-png.flaticon.com/512/3208/3208750.png"
                alt="No Access"
                className="no-access-image"
            />
            <h1 className="no-access-title">Access Denied</h1>
            <p className="no-access-message">
                You do not have permission to view this page.
                <br />
                Please contact your administrator if you believe this is a mistake.
            </p>
            <button onClick={() => window.history.back()} className="go-back-btn">
                Go Back
            </button>
        </div>
    );
};

export default NoAccess;
